module.exports = __webpack_public_path__ + "img/site-web-refonte-3.d0cb683.jpg";